/** @jsxImportSource theme-ui */
import React, { useCallback, useState } from 'react';

import AdminApi from 'api/AdminApi';

import { FlexGroup } from 'components/_common/FlexGroup';
import { Typography } from 'components/_common/Typography';
import BdButton from 'components/_controls/BdButton/BdButton';
import { LoadingSVG } from 'components/Loading/Loading';

type ResendConfirmationButtonProps = {
  userId: string;
  disabled?: boolean;
};

export const ResendConfirmationEmailButton: React.FC<ResendConfirmationButtonProps> = ({
  userId,
  disabled,
}) => {
  const [isSending, setIsSending] = useState(false);
  const [isResendSuccess, setIsResendSuccess] = useState(false);
  const resendConfirmationEmail = useCallback(() => {
    setIsSending(true);
    AdminApi.resendConfirmationEmail(userId)
      .then(() => {
        setIsResendSuccess(true);
      })
      .finally(() => {
        setIsSending(false);
      });
  }, []);

  return (
    <Typography variant="body2" color="stone90">
      <FlexGroup
        suffix={
          (isSending && (
            <FlexGroup suffix={<LoadingSVG width={12} height={12} />} alignItems="center">
              Resending...
            </FlexGroup>
          )) ||
          (disabled && 'Email already confirmed.') ||
          (isResendSuccess && 'Successfully sent email.')
        }
      >
        <BdButton
          type="tertiary"
          sx={{ width: '250px' }}
          text="Resend confirmation email"
          disabled={isSending || disabled || isResendSuccess}
          onClick={() => resendConfirmationEmail()}
        />
      </FlexGroup>
    </Typography>
  );
};
